import { GET_ME_DASHBOARD_SUMMARY } from "helpers/url_helper"
import {
  API_SUCCESS,
  API_FAIL,
  GET_USERS_DATA,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  CLEAR_ERRORS,
  UPDATE_USER,
  DELETE_USER,
  GET_USER,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  GET_DOMAINS_REQUEST,
  GET_DOMAINS_SUCCESS,
  GET_DOMAINS_FAILURE,
  ASSESSMENT_API_SUCCESS,
  ASSESSMENT_API_FAIL,
  ADD_ASSESSMENT,
  ADD_ASSESSMENT_SUCCESS,
  ADD_ASSESSMENT_FAIL,
  GET_ASSESSMENTS_DATA,
  UPDATE_USER_FAIL,
  UPDATE_USER_SUCCESS,
  DELETE_USER_FAIL,
  DELETE_USER_SUCCESS,
  UPDATE_ASSESSMENT_DATA,
  UPDATE_ASSESSMENT_SUCCESS,
  UPDATE_ASSESSMENT_FAIL,
  STEP_BACK,
  CLEAR_ASSESSMENT_ID,
  STEP_NEXT,
  CREATE_PATIENT,
  CREATE_PATIENT_SUCCESS,
  CREATE_PATIENT_FAIL,
  GET_PATIENT_DATA,
  GET_PATIENT_DATA_SUCCESS,
  GET_PATIENT_DATA_FAIL,
  UPDATE_PATIENT,
  UPDATE_PATIENT_SUCCESS,
  UPDATE_PATIENT_FAIL,
  DELETE_PATIENT,
  DELETE_PATIENT_SUCCESS,
  DELETE_PATIENT_FAIL,
  CLONE_ASSESSMENT,
  CLONE_ASSESSMENT_FAIL,
  CLONE_ASSESSMENT_SUCCESS,
  DELETE_ASSESSMENT,
  DELETE_ASSESSMENT_SUCCESS,
  DELETE_ASSESSMENT_FAIL,
  GET_ADMIN_DASHBOARD_SUMMARY_SUCCESS,
  GET_ADMIN_DASHBOARD_SUMMARY_FAILURE,
  GET_ADMIN_DASHBOARD_SUMMARY_REQUEST,
  GET_ADMIN_DASHBOARD_SIGNUPS_REQUEST,
  GET_ADMIN_DASHBOARD_SIGNUPS_SUCCESS,
  GET_ADMIN_DASHBOARD_SIGNUPS_FAILURE,
  GET_ADMIN_DASHBOARD_DOCS_MONTHLY_REQUEST,
  GET_ADMIN_DASHBOARD_DOCS_MONTHLY_SUCCESS,
  GET_ADMIN_DASHBOARD_DOCS_MONTHLY_FAILURE,
  GET_ADMIN_DASHBOARD_COMPANY_TYPES_REQUEST,
  GET_ADMIN_DASHBOARD_COMPANY_TYPES_SUCCESS,
  GET_ADMIN_DASHBOARD_COMPANY_TYPES_FAILURE,
  GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_REQUEST,
  GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_SUCCESS,
  GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_FAILURE,
  GET_ME_DASHBOARD_DAILY_DOCS_REQUEST
} from "./actionTypes"

const INIT_STATE = {
  usersData: [],
  nonSubmittedForms: [],
  loading: false,
  message: null,
  userInfo: null,
  pagination: { page: 1, limit: 10, totalPages: 1, total: 0 },
  getUserLoading: false,
  domains: [],
  data: null,
  signups: null,
  docsMonthly: null,
  companyTypes: null,
  activeSessions: null,
  assessments: [],
  updateUserLoading: false,
  createUserLoading: false,
  deleteUserLoading: false,
  confirmDeleted: false,
  getUserLoading: false,
  getAssessmentsLoading: false,
  assessmentLoading: false,
  updateAssessmentId: null,
  cloneAssessmentLoading: false,
  patientsData: [],
  createPatientLoading: false,
  updatePatientLoading: false,
  deletePatientLoading: false,
  getPatientLoading: false,
  deleteAssessmentLoading: false
}

const Dashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS_DATA:
      return {
        ...state,
        message: null,
        getUserLoading: true,
      }
    case CREATE_USER:
      return {
        ...state,
        message: null,
        createUserLoading: true,
      }
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        message: null,
        createUserLoading: false,
      }
    case CREATE_USER_FAIL:
      return {
        ...state,
        message: action.payload,
        createUserLoading: false,
      }
    case GET_USER:
      return {
        ...state,
        getUserLoading: true,
        message: "",
      }
    case GET_USER_SUCCESS:
      return {
        ...state,
        getUserLoading: false,
        selectedUser: action.payload,
      }
    case GET_USER_FAIL:
      return {
        ...state,
        getUserLoading: false,
        selectedUser: null,
        message: action.payload,
      }
    case UPDATE_USER:
      return {
        ...state,
        message: null,
        updateUserLoading: true,
      }
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        message: null,
        updateUserLoading: false,
      }
    case UPDATE_USER_FAIL:
      return {
        ...state,
        message: action.payload,
        updateUserLoading: false,
      }
    case DELETE_USER:
      return {
        ...state,
        message: null,
        deleteUserLoading: true,
      }
    case DELETE_USER_SUCCESS:
      return {
        ...state,
        confirmDeleted: true,
        message: action.payload,
        deleteUserLoading: false,
      }
    case DELETE_USER_FAIL:
      return {
        ...state,
        message: action.payload,
        deleteUserLoading: false,
      }
    case API_SUCCESS:
      return {
        ...state,
        usersData: action.payload.items,
        pagination: action.payload.pagination,
        getUserLoading: false,
      }
    case API_FAIL:
      return {
        ...state,
        message: action.payload,
        getUserLoading: false,
      }
    case GET_DOMAINS_REQUEST:
      return {
        ...state,
        getDomainsLoading: true,
        getDomainsError: "",
      }
    case GET_DOMAINS_SUCCESS:
      return {
        ...state,
        getDomainsLoading: false,
        domains: action.payload || [],
      }
    case GET_DOMAINS_FAILURE:
      return {
        ...state,
        getDomainsLoading: false,
        getDomainsError: action.payload || "Failed to fetch domains",
      }
    case GET_ADMIN_DASHBOARD_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        message: null
      }
    case GET_ME_DASHBOARD_SUMMARY:
      return {
        ...state,
        loading: true,
        message: null
      }
    case GET_ADMIN_DASHBOARD_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        message: null
      }
    case GET_ADMIN_DASHBOARD_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        message: action.error
      }

    case GET_ME_DASHBOARD_DAILY_DOCS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case GET_ADMIN_DASHBOARD_SIGNUPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_ADMIN_DASHBOARD_SIGNUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        signups: action.payload,
        error: null
      }
    case GET_ADMIN_DASHBOARD_SIGNUPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case GET_ADMIN_DASHBOARD_DOCS_MONTHLY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_ADMIN_DASHBOARD_DOCS_MONTHLY_SUCCESS:
      return {
        ...state,
        loading: false,
        docsMonthly: action.payload,
        error: null
      }
    case GET_ADMIN_DASHBOARD_DOCS_MONTHLY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case GET_ADMIN_DASHBOARD_COMPANY_TYPES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_ADMIN_DASHBOARD_COMPANY_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        companyTypes: action.payload,
        error: null
      }
    case GET_ADMIN_DASHBOARD_COMPANY_TYPES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        activeSessions: action.payload,
        error: null
      }
    case GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case ASSESSMENT_API_SUCCESS:
      return {
        ...state,
        assessments: action.payload,
        getAssessmentsLoading: false,
      }
    case ASSESSMENT_API_FAIL:
      return {
        ...state,
        message: action.payload,
        getAssessmentsLoading: false,
      }
    case GET_ASSESSMENTS_DATA:
      return {
        ...state,
        message: null,
        getAssessmentsLoading: true,
      }
    case ADD_ASSESSMENT:
      return {
        ...state,
        message: null,
        assessmentLoading: true,
      }
    case ADD_ASSESSMENT_SUCCESS:
      return {
        ...state,
        updateAssessmentId: action.payload.assessmentId,
        assessmentLoading: false,
        nonSubmittedForms: [
          ...state.nonSubmittedForms,
          {
            id: action.payload.assessmentId,
            step: 2,
          },
        ],
      }
    case ADD_ASSESSMENT_FAIL:
      return {
        ...state,
        message: action.payload,
        assessmentLoading: false,
      }
    case UPDATE_ASSESSMENT_DATA:
      return {
        ...state,
        message: null,
        assessmentLoading: true,
      }
    case UPDATE_ASSESSMENT_SUCCESS:
      let data = state.nonSubmittedForms.find(
        f => f.id === action.payload.assessmentId
      )
      if (data) {
        data = {
          ...data,
          step: data?.step == 14 ? 1 : data?.step + 1,
        }
      } else {
        data = {
          id: action.payload.assessmentId,
          step: 2,
        }
      }
      return {
        ...state,
        nonSubmittedForms: [
          ...state.nonSubmittedForms.filter(
            f => f.id !== action.payload.assessmentId
          ),
          data,
        ],
        assessmentLoading: false,
      }
    case UPDATE_ASSESSMENT_FAIL:
      return {
        ...state,
        message: action.payload,
        assessmentLoading: false,
      }
    case DELETE_ASSESSMENT:
      return {
        ...state,
        message: null,
        deleteAssessmentLoading: true,
      }
    case DELETE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        message: null,
        deleteAssessmentLoading: false,
      }
    case DELETE_ASSESSMENT_FAIL:
      return {
        ...state,
        message: action.payload,
        deleteAssessmentLoading: false,
      }
    case CLEAR_ERRORS:
      return {
        ...state,
        message: null,
        loading: false,
      }
    case STEP_BACK:
      let data1 = state.nonSubmittedForms.find(f => f.id === action.payload)
      data1 = {
        ...data1,
        step: data1.step - 1,
      }

      return {
        ...state,
        nonSubmittedForms: [
          ...state.nonSubmittedForms.filter(f => f.id !== action.payload),
          data1,
        ],
      }
    case CLEAR_ASSESSMENT_ID:
      return {
        ...state,
        updateAssessmentId: null,
      }
    case STEP_NEXT:
      let data2 = state.nonSubmittedForms.find(f => f.id === action.payload)
      data2 = {
        ...data2,
        step: data2.step + 1,
      }
      return {
        ...state,
        nonSubmittedForms: [
          ...state.nonSubmittedForms?.filter(f => f?.id !== action.payload),
          data2,
        ],
      }
    case CLONE_ASSESSMENT:
      return {
        ...state,
        cloneAssessmentLoading: true,
        message: null,
      }
    case CLONE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        cloneAssessmentLoading: false,
        assessments: [action.payload, ...state.assessments],
      }
    case CLONE_ASSESSMENT_FAIL:
      return {
        ...state,
        cloneAssessmentLoading: false,
        message: action.payload,
      }
    case CREATE_PATIENT:
      return {
        ...state,
        createPatientLoading: true,
        message: null,
      }
    case CREATE_PATIENT_SUCCESS:
      return {
        ...state,
        createPatientLoading: false,
        patientsData: [action.payload, ...state.patientsData],
      }
    case CREATE_PATIENT_FAIL:
      return {
        ...state,
        createPatientLoading: false,
        message: action.payload,
      }
    case GET_PATIENT_DATA:
      return {
        ...state,
        loading: true,
        message: null,
      }
    case GET_PATIENT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        patientsData: Array.isArray(action.payload) ? action.payload : [],
      }
    case GET_PATIENT_DATA_FAIL:
      return {
        ...state,
        loading: false,
        message: action.payload,
      }
    case UPDATE_PATIENT:
      return {
        ...state,
        updatePatientLoading: true,
        message: null,
      }
    case UPDATE_PATIENT_SUCCESS:
      return {
        ...state,
        updatePatientLoading: false,
        patientsData: state.patientsData.map(patient => {
          if (patient.id === action.payload.id) {
            return { ...patient, ...action.payload }
          }
          return patient
        }),
      }

    case UPDATE_PATIENT_FAIL:
      return {
        ...state,
        updatePatientLoading: false,
        message: action.payload,
      }
    case DELETE_PATIENT:
      return {
        ...state,
        deletePatientLoading: true,
        message: null,
      }
    case DELETE_PATIENT_SUCCESS:
      return {
        ...state,
        deletePatientLoading: false,
        patientsData: state.patientsData.filter(
          patient => patient.id !== action.payload
        ),
      }
    case DELETE_PATIENT_FAIL:
      return {
        ...state,
        deletePatientLoading: false,
        message: action.payload,
      }

    default:
      return state
  }
}
export default Dashboard
